import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ModalHeaderBlock" }
const _hoisted_2 = { class: "ModalContentBlock" }
const _hoisted_3 = { class: "DashboardPreviewTextBlock" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "DashboardKeyResearchQuestionsWrapper" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "CarouselCounterWrapper" }
const _hoisted_10 = { class: "CarouselCounter" }
const _hoisted_11 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "modalContent",
    class: _normalizeClass([
			'DashboardPreviewModal',
			{ 'ModalLayoutHidden': _ctx.isModalStateCarousel }
		])
  }, [
    (_ctx.isModalStateOverview)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.dashboardName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardDescriptionParagraphs, (paragraph) => {
                return (_openBlock(), _createElementBlock("p", { key: paragraph }, _toDisplayString(paragraph), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", {
              class: "DashboardPreviewImageWrapper",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCarousel && _ctx.openCarousel(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.retrieveCarouselImageUrl(0),
                class: "DashboardPreviewImage DashboardPreviewImagePrimary",
                alt: "Dashboard preview image"
              }, null, 8 /* PROPS */, _hoisted_4),
              _createElementVNode("img", {
                src: _ctx.retrieveCarouselImageUrl(1),
                class: "DashboardPreviewImage DashboardPreviewImageSecondary",
                alt: "Dashboard preview image"
              }, null, 8 /* PROPS */, _hoisted_5),
              (_ctx.amountOfCarouselSlides > 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.retrieveCarouselImageUrl(2),
                    class: "DashboardPreviewImage DashboardPreviewImageSecondary",
                    alt: "Dashboard preview image"
                  }, null, 8 /* PROPS */, _hoisted_6))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardKeyResearchQuestions, (question) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: question,
                  class: "DashboardPreviewTextBlock"
                }, _toDisplayString(question), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("button", {
              class: "ChampionButton RequestDemoButton",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRequestDemoClick && _ctx.handleRequestDemoClick(...args)))
            }, " Request a Demo ")
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.isModalStateCarousel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amountOfCarouselSlides, (slide, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `carouselImage-${index}`
              }, [
                (index === _ctx.carouselIndex)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.retrieveCarouselImageUrl(index),
                      class: "CarouselImageLargeActive",
                      alt: "Carousel image large"
                    }, null, 8 /* PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("button", {
              class: "CarouselButton CarouselBackward",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveCarouselBackward && _ctx.moveCarouselBackward(...args)))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "lnr-chevron-left" }, null, -1 /* CACHED */)
            ]))]),
            _createElementVNode("button", {
              class: "CarouselButton CarouselForward",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveCarouselForward && _ctx.moveCarouselForward(...args)))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "lnr-chevron-right" }, null, -1 /* CACHED */)
            ]))]),
            _createElementVNode("button", {
              class: "CarouselCloseButton",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.shouldModalBeClosed && _ctx.shouldModalBeClosed(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
            ]))]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.carouselIndex + 1) + " / " + _toDisplayString(_ctx.amountOfCarouselSlides), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amountOfCarouselSlides, (slide, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: `carouselThumbnail-${index}`,
                  src: _ctx.retrieveCarouselImageUrl(index),
                  class: "CarouselThumbnailImage",
                  alt: "Carousel image thumbnail",
                  onClick: ($event: any) => (_ctx.moveCarouselToIndex(index))
                }, null, 8 /* PROPS */, _hoisted_11))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}